import FacilityRepository      from "../../../domain/facility/FacilityRepository";
import FetchStatusRepository   from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository        from "../../../domain/fundamentals/message/notify/NotifyRepository";
import FetchStatusDataSource   from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import FacilityDataSource      from "../../../infrastructure/datasource/facility/FacilityDataSource";
import NotifyDataSource        from "../../../infrastructure/datasource/notify/NotifyDataSource";
import { facilitiesSetAction } from "../../../infrastructure/redux/facility/FacilityAction";

class GetFacilities {
  constructor(
    private readonly dispatch,
    private readonly facilityRepository: FacilityRepository = new FacilityDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
  ) {
  }

  public async execute() {
    this.fetchStatusRepository.start();
    try {
      const facilities = await this.facilityRepository.findAll();
      this.dispatch(facilitiesSetAction(facilities));
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetFacilities;